import styled from 'styled-components';
import { Body } from '@trevor/ui-components';

export const SubscriptionDescriptionContainer = styled.div`
  > p {
    margin-top: var(--spacing-s);
  }
`;

export const SubscriptionFeaturesContainer = styled.div`
  margin-top: var(--spacing-xl);

  > p {
    margin-bottom: var(--spacing-s);
  }

  > ul {
    padding-inline-start: calc(var(--spacing-m) * 2);
  }
`;

export const DiscussPricingText = styled(Body).attrs({ variant: 2 })`
  text-align: center;
  margin-top: calc(var(--spacing-S) * -1);

  > a {
    font-size: inherit;
    font-weight: inherit;
    display: unset;
  }
`;
